import $ from 'jquery';

const SizingService = {
  initialize: function () {},
  setMinHeight($element, config) {
    let minHeight = 0;

    if (config.override) {
      $element.addClass('override-min-height');
    }

    if (config.value) {
      minHeight = this.getDimensionValueParsed(config.value, 'outerHeight');
    } else if (config.calculate) {
      minHeight = this.getDimensionValueCalculated(config.calculate, 'outerHeight');
    }

    $element.css({
      'min-height': minHeight,
    });
  },
  getTotalForADimension(dimensionsArray, type) {
    let totalForADimension = 0;

    for (const item of dimensionsArray) {
      if (typeof item === 'number') {
        totalForADimension += item;
      } else if ($(item).length) {
        totalForADimension += $(item)[type](true);
      }
    }
    return totalForADimension;
  },
  getDimensionValueParsed(value, type) {
    return Array.isArray(value) ? `${this.getTotalForADimension(value, type)}px` : value;
  },
  getDimensionValueCalculated(config, type) {
    const valueA = this.getDimensionValueParsed(config.valueA, type);
    const valueB = this.getDimensionValueParsed(config.valueB, type);
    const operations = {
      subtract: '-',
      add: '+',
    };

    return `calc(${valueA} ${operations[config.operation]} ${valueB})`;
  },
};

export default SizingService;
